export interface Conversation {
    id: string;
    // The stork driver the conversation is with
    driverId?: string;
    // The counterpart as seen by the operator; drivers read `organizationName` instead
    participantName: string;
    participantInitials: string;
    // Both sides of the conversation, so each client can pick the one that isn't itself
    driverName?: string;
    organizationName?: string;
    lastSeen?: Date;
    // Only set when the driver currently has an active/pending trip
    contextId?: string;
    conversationSubtitle?: string; // e.g. "Chacabuco (M…) → MILLAN S.A. LAS H…"
    // Firestore-sourced: not known until the client's live message subscription resolves it
    isOnline?: boolean;
    lastMessage?: string;
    lastMessageTime?: Date;
    unreadCount: number;
    isUrgent: boolean;
    // When the caller last read this chat (Mongo-backed, ISO string — arrives over GraphQL as
    // a plain string, not a Date instance). Used to count unread Firestore messages.
    lastReadAt?: string;
}

export interface Message {
    id: string;
    type: 'text' | 'audio';
    content: string; // text content or audio URL
    audioDuration?: number; // seconds
    direction: 'incoming' | 'outgoing';
    timestamp: Date;
    // Denormalized display name of the sender, only set for OPERATOR messages
    senderName?: string;
}
